import React from "react";
import moment from "moment-timezone";
import styles from "./TradeSetups.module.css";
import type { CftcRegimeSnapshot } from "./cftcRegimeUtils.ts";

type Props = {
  snapshot: CftcRegimeSnapshot | null;
  stale: boolean;
};

export const MacroRegimeBadge = ({ snapshot, stale }: Props) => {
  const label = snapshot?.regimeLabel
    ? `Macro Regime: ${snapshot.regimeLabel}`
    : "Macro Regime: Unavailable";
  const asOfLabel = snapshot?.asOfDate
    ? `CFTC as-of Tue ${moment(snapshot.asOfDate).format("MMM D")}`
    : "CFTC as-of —";
  const publishedLabel = snapshot?.publishedDate
    ? `Published Fri ${moment(snapshot.publishedDate).format("MMM D")}`
    : null;

  return (
    <div className={styles.macroBadge}>
      <span className={styles.macroBadgeLabel}>
        {label} {stale ? "(stale)" : ""}
      </span>
      <span className={styles.macroBadgeAsOf}>
        {asOfLabel}
        {publishedLabel ? ` · ${publishedLabel}` : ""}
      </span>
      <span className={styles.macroTooltip}>
        <span className={styles.macroTooltipTitle}>Macro Regime (CFTC)</span>
        {snapshot ? (
          <span className={styles.macroTooltipBody}>
            Weekly positioning context based on CFTC data (as-of Tuesday, published Friday).
            <br />
            This does not change intraday setup detection — it’s for context.
          </span>
        ) : (
          <span className={styles.macroTooltipBody}>
            Macro regime is unavailable for this asset. Intraday setups still run normally.
          </span>
        )}
        {snapshot && (
          <span className={styles.macroTooltipMeta}>
            {`Macro bias: ${snapshot.macroBias} · Confidence: ${snapshot.confidence || "—"}`}
          </span>
        )}
        {stale && (
          <span className={styles.macroTooltipMeta}>
            Positioning is aging; interpret confluence with extra caution.
          </span>
        )}
      </span>
    </div>
  );
};
